module.exports = __webpack_public_path__ + "img/inspiring_background.7564b94.jpg";